import React from 'react'
import { WMSTileLayer } from 'react-leaflet'

function EcuadorAccesibilidadLayer({ opacity = 0.6 }) {
  return (
    <WMSTileLayer
      layers="acc_cafe_cacao_reclas"
      format="image/png"
      version="1.1.1"
      transparent
      tiled
      url={`https://g8a078u1g6.execute-api.eu-west-1.amazonaws.com/app/wms-ecuador/geosigtierras/accesibilidad/wms`}
      opacity={opacity}
    />
  )
}

export default EcuadorAccesibilidadLayer
